if (typeof wp !== 'undefined' && typeof wp.data !== 'undefined') {

  (function(wp) {
    if (!wp || !wp.data || !wp.data.select || !wp.data.dispatch) {
      return;
    }

    var select = wp.data.select;
    var dispatch = wp.data.dispatch;
    var storeName = 'core/block-editor';

    function ensureAcfBlocksEditMode() {
      var editor = select(storeName);

      if (!editor || !editor.getBlocks) {
        return;
      }

      var blocks = editor.getBlocks();

      if (!Array.isArray(blocks) || blocks.length === 0) {
        return;
      }

      var queue = [];

      function walk(blockList) {
        blockList.forEach(function(block) {
          if (!block || !block.name || !block.clientId) {
            return;
          }

          if (block.name.indexOf('acf/block-') === 0) {
            var attrs = block.attributes || {};

            if (attrs.mode && attrs.mode !== 'edit') {
              queue.push(block.clientId);
            }
          }

          if (Array.isArray(block.innerBlocks) && block.innerBlocks.length) {
            walk(block.innerBlocks);
          }
        });
      }

      walk(blocks);

      if (!queue.length) {
        return;
      }

      queue.forEach(function(clientId) {
        dispatch(storeName).updateBlockAttributes(clientId, { mode: 'edit' });
      });
    }

    wp.domReady(function() {
      ensureAcfBlocksEditMode();
      wp.data.subscribe(ensureAcfBlocksEditMode);
    });
  })(window.wp);

}
